import { render, staticRenderFns } from "./NewGsCalendarDayContent.vue?vue&type=template&id=628fc6ef&scoped=true"
import script from "./NewGsCalendarDayContent.vue?vue&type=script&lang=js"
export * from "./NewGsCalendarDayContent.vue?vue&type=script&lang=js"
import style0 from "./NewGsCalendarDayContent.vue?vue&type=style&index=0&id=628fc6ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628fc6ef",
  null
  
)

export default component.exports